import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export type QuotePriority = 'urgent' | 'normal' | 'low';

const PRIORITY_BADGE: Record<QuotePriority, { variant: 'red' | 'info' | 'gray'; fallback: string }> = {
  urgent: { variant: 'red', fallback: 'Urgent' },
  normal: { variant: 'info', fallback: 'Normal' },
  low: { variant: 'gray', fallback: 'Low' },
};

/**
 * Colored operations-triage priority chip. Renders nothing when the quote
 * has no priority set (legacy quotes) so unset cards stay uncluttered.
 */
export function QuotePriorityBadge({ priority }: { priority?: string | null }) {
  const { t } = useTranslation('operations');
  if (!priority || !(priority in PRIORITY_BADGE)) return null;
  const { variant, fallback } = PRIORITY_BADGE[priority as QuotePriority];
  return <Badge variant={variant}>{t(`quotePriority.${priority}`, fallback)}</Badge>;
}
